window.onload = function () {


};

// ページの読み込みと解析が完了した後に有効になる処理を記述
window.addEventListener('DOMContentLoaded', function (e) {

    // 検索ボタンを押したときの処理
    $(document).on('click', '#execute_search', function () {
        let to_url;
        to_url = window.location.protocol + '//' + window.location.host + window.location.pathname;

        const from = parseInt($('#price_from').val());
        const to = parseInt($('#price_to').val());

        // 両方入力されている場合のみ大小比較
        if (from && to && from > to) {
            alert('最小価格（FROM）には最大価格（TO）より小さい値を入力してください。');
            return false;
        }

        // IE対応: new URLの方がいいかと思ったが、IE未対応のため、パラメータ文字列結合
        var fields = {
            "item": "select_category",
            "price_from": "price_from",
            "price_to": "price_to",
            "price": "select_price",
        };

        var queryArray = [];
        for (var paramName in fields) {
            var elementId = fields[paramName];
            var val = document.getElementById(elementId).value;

            if (
                paramName == "price"
                && (from > 0 || to > 0)
            ) {
                continue;
            }

            // 空文字許容：値が空でも「param=」として連結
            queryArray.push(encodeURIComponent(paramName) + "=" + encodeURIComponent(val));
        }

        to_url = to_url + "?" + queryArray.join("&");
        console.log('goto ' + to_url);
        window.location.href = to_url;
    });

});
